import { FadeIn } from '~/components/subscription/branch-lp/fade-in'
import image1 from './images/1.jpg'
import image2 from './images/2.jpg'
import image3 from './images/3.jpg'

export const QualitySection: React.FC = () => {
  const points = [
    {
      point: 'POINT 1',
      title: 'ひとつひとつ人の目で品質チェック',
      body: '市場から届いた枝に折れや傷みがないか経験豊富なスタッフが目視で確認。状態のよいものをセレクトしてお届けします。',
      src: image1,
      alt: '枝の検品作業',
    },
    {
      point: 'POINT 2',
      title: '下処理・水揚げをしてから出荷',
      body: 'FLOWERではすべての枝に下処理と水揚げを行い、元気をチャージしてから発送しています。鮮度を保ったまま届けるためのひと手間です。',
      src: image2,
      alt: '水揚げ作業',
    },
    {
      point: 'POINT 3',
      title: '専用梱包でお届け',
      body: '枝ものは大きくて繊細。折れないよう専用の梱包材を使って出荷します。万が一、受け取った商品に「枯れている」「折れている」などの不備があった場合は、返金または代替品をお送りします。',
      src: image3,
      alt: '梱包作業',
    },
  ]

  return (
    <section className="py-20 md:py-28 bg-white px-5">
      <div className="max-w-2xl mx-auto">
        <h2 className="text-center text-2xl md:text-3xl font-medium text-black leading-relaxed mb-12">品質へのこだわり</h2>
        <div className="space-y-20 md:space-y-24">
          {points.map((r, i) => (
            <FadeIn key={i}>
              <p className="text-[11px] font-display tracking-[0.2em] text-dark-gray">{r.point}</p>
              <h3 className="mt-3 text-xl md:text-2xl font-medium text-black leading-relaxed">{r.title}</h3>
              <div className="mt-6 aspect-4/3 rounded-xl overflow-hidden bg-gray/30">
                <img src={r.src} alt={r.alt} className="w-full h-full object-cover" />
              </div>
              <p className="mt-6 text-[15px] text-main leading-[1.9]">{r.body}</p>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  )
}
